import { Container, SxProps, Theme } from '@mui/material';

const PageContainer = ({
    children,
    maxWidth,
    sx,
}: {
    children: React.ReactNode;
    maxWidth?: false | 'xs' | 'sm' | 'md' | 'lg' | 'xl';
    sx?: SxProps<Theme>;
}) => {
    return (
        <Container
            maxWidth={maxWidth || false}
            sx={{
                paddingTop: 2,
                paddingBottom: 2,
                paddingLeft: { xs: 1, sm: 2 },
                paddingRight: { xs: 1, sm: 2 },
                minHeight: '100%',
                ...sx,
            }}
        >
            {children}
        </Container>
    );
};

export default PageContainer;
